import { Pagination } from "@mui/material";
const TablePagination = ({ setPage, page, setLimit, limit, totalPages }) => {
  const pageCount = Math.ceil(totalPages / limit);
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  const handleLimitChange = (event, newLimit) => {
    setLimit(newLimit);
  };

  return (
    <Pagination
      count={pageCount}
      color="primary"
      shape="rounded"
      siblingCount={1}
      onChange={handlePageChange}
      onChangeRowsPerPage={handleLimitChange}
      page={page}
    />
  );
};

export default TablePagination;
